const testIds = {
  //  Violations
  SOD_VIOLATIONS_PAGE: 'aag-sod-violations-page',
  SOD_VIOLATIONS_PAGE_HEADER: 'aag-sod-violations-page-header',
  SOD_VIOLATIONS_PAGE_HEADER_EXP_BTN:
    'aag-sod-violations-page-header-export-btn',
  SOD_VIOLATIONS_PAGE_BODY: 'aag-sod-violations-page-body',
  SOD_VIOLATIONS_PAGE_SIDEPANEL: 'aag-sod-violations-page-sidepanel',
  SOD_VIOLATIONS_PAGE_FOOTER: 'aag-sod-violations-page-footer',
  // Recommendation
  SOD_RECOMMENDATION_PAGE: 'aag-sod-recommendation-page',
  // Details
  SOD_DETAILS_PAGE: 'aag-sod-details-page',
  // Report
  SOD_REPORT_PAGE: 'aag-sod-report-page',
  // Shared
  SOD_CONTROLS: 'aag-sod-controls',
  SOD_CONTROLS_FILTER_BTN: 'aag-sod-filter-button',
  SOD_CONTROLS_SEARCH_BOX: 'aag-sod-search-box',
  SOD_CONTROLS_INSIGHTS_BTN: 'aag-sod-insights-button',
  SOD_CONTROLS_ADD_REMOVE_BUTTON: 'aag-sod-add-remove-button',
  SOD_CONTROLS_MODE_1: 'aag-sod-mode-1',
  SOD_CONTROLS_MODE_2: 'aag-sod-mode-2',
  SOD_CONTROLS_CLEAR_BTN: 'aag-sod-clear-button',
  SOD_FIELDSET: 'aag-sod-fieldset',
  SOD_MITIGATING_CONTROLS: 'aag-sod-mitigating-controls',
  SOD_USER_CARD: 'aag-sod-user-card',
  // Violations tab
  SOD_VIOLATIONS_TAB_LIST: 'aag-sod-violations-tab-list',
  SOD_VIOLATIONS_TAB_LIST_ROW: 'aag-sod-violations-tab-list-row',
  SOD_VIOLATIONS_TAB_SIDE_PANEL: 'aag-sod-violations-tab-sidepanel',
  // Entitlement tab
  SOD_ENTITLEMENT_TAB: 'aag-sod-entitlement-tab',
  // Mitigation
  SOD_MITIGATE_MODAL_LOADER: 'aag-sod-mitigate-modal-loader',
  SOD_MITIGATE_RECOMMENDED_STAR: 'aag-sod-mitigate-recommended-star',
  // Remediate
  SOD_REMEDIATE_MODAL_LOADER: 'aag-sod-remediate-modal-loader',
} as const;

export default testIds;
